import React from "react";
import { Navbar, Nav, NavDropdown, Offcanvas } from "react-bootstrap";
import top from "../../assests/top.png";
import "./Header.css";
import { Link } from "react-router-dom";

const NavMobile = ({ show, handleClose, handleScrollToTop }) => {
  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
    
        className=" jab_navbar_mobile d-block d-xl-none"
      >
        <Offcanvas.Header closeButton className="common_bgcolor">
          <Offcanvas.Title>
            <h1 className=" fw-bold display-6 ">
              Journal of Applied Bioanalysis
            </h1>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            <Nav.Link as={Link} to="/" onClick={handleScrollToTop}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/about" onClick={handleScrollToTop}>
              About
            </Nav.Link>
            <Nav.Link
              to="/information/article-processing-charges/0-general-information-on-article-processing-charges-apc"
              as={Link}
              onClick={handleScrollToTop}
            >
              {" "}
              Article Processing Charges{" "}
            </Nav.Link>

            <NavDropdown title="Archives" id="basic-nav-dropdown-resources">
              <NavDropdown.Item
                to="/current-issue"
                as={Link}
                onClick={handleScrollToTop}
              >
                Current Issue
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/issue-archive"
                as={Link}
                onClick={handleScrollToTop}
              >
                All Archive
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="For Authors"
              id="basic-nav-dropdown-forauthor"
              className=""
            >
              <NavDropdown.Item
                to="/information/for-authors-2/0-information-for-authors"
                as={Link}
                onClick={handleScrollToTop}
              >
                Information For Authors
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/information/for-authors-2/1-useful-resources-for-authors"
                as={Link}
                onClick={handleScrollToTop}
              >
                Useful Resources for Authors
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/information/for-authors-2/2-manuscript-submission-amp-instructions-for-authors"
                as={Link}
                onClick={handleScrollToTop}
              >
                Manuscript Submission & Instructions for Authors
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/information/for-authors-2/5-funding-of-apcs-and-bpcs"
                as={Link}
                onClick={handleScrollToTop}
              >
                Funding of APCs and BPCs
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/information/for-authors-2/10-general-peer-review-and-editorial-procedures"
                as={Link}
                onClick={handleScrollToTop}
              >
                General Peer-Review and Editorial Procedures
              </NavDropdown.Item>

              <NavDropdown.Item
                to="/information/for-authors-2/11-editorial-decision-and-revision"
                as={Link}
                onClick={handleScrollToTop}
              >
                Editorial Decision and Revision
              </NavDropdown.Item>

              <NavDropdown.Item
                to="/information/for-authors-2/12-long-term-archiving"
                as={Link}
                onClick={handleScrollToTop}
              >
                Long Term Archiving
              </NavDropdown.Item>

                 <NavDropdown.Item
                                to="/information/for-authors-2/13-bsp-guidelines-on-artificial-intelligence-and-authorship-"
                                as={Link}
                                onClick={handleScrollToTop}
                              >
                                BSP Guidelines on Artifical Intelligence and Authorship
                              </NavDropdown.Item>

              <NavDropdown.Item
                to="/journal-information"
                as={Link}
                onClick={handleScrollToTop}
              >
                Journal Information
              </NavDropdown.Item>
                      <NavDropdown.Item
                                to="/information/editorial-criteria-and-processes/0--how-to-submit-an-article-"
                                as={Link}
                                onClick={handleScrollToTop}
                              >
                               Editorial Criteria and Processes
                              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title="For Reviewers"
              id="basic-nav-dropdown-forreviews"
              className=""
            >
              <NavDropdown.Item
                to="/for-reviewers/0-benefits-for-peer-reviewers"
                as={Link}
                onClick={handleScrollToTop}
              >
                Benifits for Peer-Reviewers
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/for-reviewers/1-invitation-to-join-our-peer-reviewer-database"
                as={Link}
                onClick={handleScrollToTop}
              >
                Invitation to Join our Peer-Reviewer Database
              </NavDropdown.Item>

              <NavDropdown.Item
                to="/for-reviewers/2-invitation-to-review"
                as={Link}
                onClick={handleScrollToTop}
              >
                Invitation to Review
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/for-reviewers/3-potential-conflicts-of-interests"
                as={Link}
                onClick={handleScrollToTop}
              >
                Potential Conflicts of Interests
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/for-reviewers/4-confidentiality-and-anonymity"
                as={Link}
                onClick={handleScrollToTop}
              >
                Confidentiality and Anonymity
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/for-reviewers/5-timely-review-reports"
                as={Link}
                onClick={handleScrollToTop}
              >
                Timely Review Reports
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/for-reviewers/6-rating-the-manuscript"
                as={Link}
                onClick={handleScrollToTop}
              >
                Rating the Manuscipt
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/for-reviewers/7-overall-recommendation"
                as={Link}
                onClick={handleScrollToTop}
              >
                Overall Recommendation
              </NavDropdown.Item>
              <NavDropdown.Item
                to="/for-reviewers/8-peer-review-report"
                as={Link}
                onClick={handleScrollToTop}
              >
                Peer-review Report
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link
              to="/submit-article"
              as={Link}
              className=""
              onClick={handleScrollToTop}
            >
              Submit article
              <img src={top} alt="icon" width={15} className="mx-2" />
            </Nav.Link>

       
          
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default NavMobile;
